/**
 * Leviathan.js
 * The Leviathan Enemy class
 */

import { Game } from "pixi_core";
import { BubbleColor, Enemies, EnemyAbilities, GameEvents, NB_MAX_ENEMIES } from "../Constants";
import { Enemy } from "./Enemy";

export class Leviathan extends Enemy {
    /**
     * @public
     * @param {String} enemyName
     * @param {Object} enemyData
     * @param {Number} index
     * @param {Boolean} [summoned] - Summoned by an ability
     */
    constructor(enemyName, enemyData, index, summoned) {
        super(enemyName, enemyData, index, summoned);

        const probHeavySlam = Game.utils.assertNumber(enemyData.ProbHeavySlam, 1);

        // Single ability choice
        this._abilityChoices.addChoice(EnemyAbilities.eHEAVY_SLAM, probHeavySlam);

        /** @private @type {Enemies[]} - Which enemies can be added by the Troops Drop */
        this._troopsDropped = [Enemies.eCHITAURI_ARTIFICIER, Enemies.eCHITAURI_FIGHTER, Enemies.eCHITAURI_RIDER];

        /** @private @type {Number} - Probability of using Troops Pod */
        this._probTroopsPod = Game.utils.assertNumber(enemyData.ProbTroopsPod, 1);
    }

    /**
     * Choose the next action in this enemy's attack phase
     * @protected
     * @override
     */
    _chooseNextAction() {
        if (this._nbActionsPerformed < this._nbActionsPerTurn && this._hp > 0) {
            ++this._nbActionsPerformed;

            if (this._currentAttackTimer > 0) {
                this._regularAttack();
            } else {
                let ability = this._chooseAbility();
                // GDD: [75%] chance to use duplicate skill if there is an empty slot in the enemy team
                const response = {};
                Game.fire(GameEvents.eREQUEST_ACTIVE_ENEMIES, response);
                let probMassProduction = Math.random();

                if (probMassProduction < this._probTroopsPod / 100 && response.activeEnemies.length < NB_MAX_ENEMIES) {
                    ability = EnemyAbilities.eTROOPS_POD;
                }

                this._beginAbility(ability);
            }
        } else {
            this._onAttackPhaseCompleted();
        }
    }

    /**
     * @protected
     * @override
     * @param {EnemyAbilities} abilityName
     * @param {{x: Number, y: Number}} startPos
     */
    _useAbility(abilityName, startPos) {
        switch (abilityName) {
            case EnemyAbilities.eHEAVY_SLAM:
                Game.fire(GameEvents.eGAME_ABILITY_HEAVY_SLAM, {
                    attackDamage: this._attackDamage,
                    nbBubbles: this._nbBubblesAdd,
                    bubbleColor: BubbleColor.eRANDOM,
                    startPos: startPos,
                    callback: this._onAbilityCompleted.bind(this)
                });
                break;
            case EnemyAbilities.eTROOPS_POD:
                let dropRandom = Math.floor(Math.random() * this._troopsDropped.length);
                Game.fire(GameEvents.eGAME_ABILITY_TROOPS_POD, this._troopsDropped[dropRandom], this._onAbilityCompleted.bind(this));
                break;
            default:
                console.error("[Leviathan._useAbility] Invalid ability name : " + abilityName);
                this._chooseNextAction();
        }
    }
}
